<div class="dynamic-list" [ngClass]="{'pb-3': items.length > 0, 'borderless': borderless}">
    <ng-content ></ng-content>
</div>
